export const google_vertex_anthropicModels = {
    id: "google-vertex-anthropic",
    name: "Vertex",
    npm: "@ai-sdk/google-vertex",
    doc: "https://cloud.google.com/vertex-ai/generative-ai/docs/partner-models/claude",
    env: [
        "GOOGLE_VERTEX_PROJECT",
        "GOOGLE_VERTEX_LOCATION",
        "GOOGLE_APPLICATION_CREDENTIALS",
    ],
    models: {
        "claude-3-5-haiku@20241022": {
            id: "claude-3-5-haiku@20241022",
            name: "Claude Haiku 3.5",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-07-31",
            release_date: "2024-10-22",
            last_updated: "2024-10-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.8,
                output: 4,
                cache_read: 0.08,
                cache_write: 1,
            },
            limit: {
                context: 200000,
                output: 8192,
            },
        },
        "claude-opus-4@20250514": {
            id: "claude-opus-4@20250514",
            name: "Claude Opus 4",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03-31",
            release_date: "2025-05-22",
            last_updated: "2025-05-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 15,
                output: 75,
                cache_read: 1.5,
                cache_write: 18.75,
            },
            limit: {
                context: 200000,
                output: 32000,
            },
        },
        "claude-3-5-sonnet@20241022": {
            id: "claude-3-5-sonnet@20241022",
            name: "Claude Sonnet 3.5 v2",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04-30",
            release_date: "2024-10-22",
            last_updated: "2024-10-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.3,
                cache_write: 3.75,
            },
            limit: {
                context: 200000,
                output: 8192,
            },
        },
        "claude-opus-4-1@20250805": {
            id: "claude-opus-4-1@20250805",
            name: "Claude Opus 4.1",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03-31",
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 15,
                output: 75,
                cache_read: 1.5,
                cache_write: 18.75,
            },
            limit: {
                context: 200000,
                output: 32000,
            },
        },
        "claude-3-7-sonnet@20250219": {
            id: "claude-3-7-sonnet@20250219",
            name: "Claude Sonnet 3.7",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10-31",
            release_date: "2025-02-19",
            last_updated: "2025-02-19",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.3,
                cache_write: 3.75,
            },
            limit: {
                context: 200000,
                output: 64000,
            },
        },
        "claude-sonnet-4@20250514": {
            id: "claude-sonnet-4@20250514",
            name: "Claude Sonnet 4",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03-31",
            release_date: "2025-05-22",
            last_updated: "2025-05-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.3,
                cache_write: 3.75,
            },
            limit: {
                context: 200000,
                output: 64000,
            },
        },
    },
};
export default google_vertex_anthropicModels;
//# sourceMappingURL=google-vertex-anthropic.js.map